import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Typography, Form, Button, Row, Col, Icon, Modal, Input } from 'antd'
import { Link } from 'react-router-dom'
import { changeFormatdateSlip } from '../../../../../utils/formatdate'
import moment from 'moment'
import { alertMessage } from '../../../../../utils/message'

const { TextArea } = Input;
const { Text, Title } = Typography


class ViewInviteMeeting extends Component {
	state = {
		textNote: "",
		idNote: "",
		showModalAddNote: false,
		showModalSuccess: false,
	}
	cardBox = (dataMeeting) => {
		let content = [];
		for (let index = 1; index <= dataMeeting.length; index++) {
			content.push(
				<Col span={24} className={"box-show-meeting p-3 my-3"}>
					<p>{dataMeeting[index].subject}</p>
				</Col>
			);
		}
		return content;
	}
	clickRefuse = () => {
		console.log("refuse");
	}
	handleCancel = () => {
		this.setState({
			textNote: "",
			showModalAddNote: false,
			showModalSuccess: false,
		})
	}
	handleOkSaveNoteSuccess = () => {
      if(this.state.textNote){
         this.setState({
            showModalAddNote: false,
            showModalSuccess: true,
         })
         this.props.commentSummary(this.state.idNote, this.state.textNote)
         setTimeout(() => {
            this.setState({
               showModalSuccess: false
            })
         }, 1000);
      }else{
         alertMessage("error", "กรุณากรอกข้อมูลให้ครบถ้วน")
      }
		
	}
	addNote = (id, changeDetail) => {
		// console.log("changeDetail",changeDetail);
		this.setState({
			showModalAddNote: true,
			idNote: id,
			textNote: ""
		})
	}

	onChange = ({ target: { value } }) => {
      console.log("valuvaluee", value)
		this.setState({ textNote: value });
		// console.log("this.state.value",this.state.value);
	};
	render() {
		const { dataMeeting, acceptSummary, commentSummary } = this.props
		const { getFieldDecorator } = this.props.form;
		return (
			<Row gutter={16} >
				{/* {this.cardBox(dataMeeting)} */}

				<Modal
                destroyOnClose={true}
					className={'list-invite-external-modal'}
					visible={this.state.showModalAddNote}
					onCancel={this.handleCancel}
					footer={[
						<Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>
							ยกเลิก</Button>,
						<Button key="submit" className={'btn-modal-confirm'} onClick={this.handleOkSaveNoteSuccess}>
							ยืนยัน</Button>,
					]}
				>
					<div>
						<p style={{ fontSize: "20px" }}>
							แสดงความคิดเห็น
						</p>
						<TextArea
							// value={this.state.textNote}
							onChange={this.onChange}
							rows={8}
						/>
					</div>
				</Modal>
				<Modal
					className={'meeting-management-modal'}
					visible={this.state.showModalSuccess}
					onCancel={this.handleCancel}
					footer={null}
					closable={false}
				>
					<div className={'py-5'} style={{ textAlign: 'center', color: "#178991" }}>
						<Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="check-circle" />
						<p style={{ fontSize: "20px" }}>
							บันทึกสำเร็จ
						</p>
					</div>
				</Modal>
				{dataMeeting && dataMeeting.length > 0 ?
					dataMeeting.map((MeetingList, i) => {
						return (
							<Col span={24} className={"box-show-meeting p-3 pl-4 my-3"}>

								<Row gutter={16}>
									<Col span={16} className="pl-3">
										<p className={"text-box-meeting"}><Icon className="icon-box-meeting" type="sound" />{MeetingList.subject}</p>
									</Col>
									<Link
										to={{
											pathname: `/meetingmanagement/NoteMeetingForm/`,
											search: 'id=' + MeetingList.id,
										}}>
										<Col span={7} align="end">
											<Icon type="right" style={{ color: "#666666" }} />
										</Col>
									</Link>
									<Col span={16} className="pl-3">
										<p className={"text-box-meeting"}><Icon className="icon-box-meeting" type="clock-circle" />{changeFormatdateSlip(moment(MeetingList.startDate))} / {moment(MeetingList.startDate).format('HH:ss')} - {moment(MeetingList.endDate).format('HH:ss')} น.</p>
									</Col>
									<Col span={7}>

									</Col>
									<Col span={12} className="pl-3">
										<p className={"text-box-meeting"}><Icon className="icon-box-meeting" type="environment" />{MeetingList.location}</p>
									</Col>
									<Col span={12} lg={2} align="end">
									</Col>
									<Col span={12} lg={{ span: 4 }} align="end">
										<Button 
                                 className={'button-meeting-approve mt-3 mt-lg-0'} 
                                 style={{ 
                                    color: (MeetingList.status == "Accept" ? "#178991" : "#FDB75D"), 
                                    backgroundColor: "transparent",
                                    cursor: (MeetingList.status == "Accept" ? "no-drop" : "pointer"), 
                                 }} 
                                 onClick={() => (MeetingList.status == "Accept" ? null : acceptSummary(MeetingList.id))}
                              >
											<Icon type="like" />เห็นชอบ
                              </Button>
									</Col>
									<Col span={12} lg={{ span: 4 }} align="end">
										<Button 
                                 className={'button-meeting-approve mt-3 mt-lg-0'} 
                                 style={{ 
                                    color: (MeetingList.changeDetail ? "#178991" : "#808080"), 
                                    backgroundColor: "transparent" 
                                 }} 
                                 onClick={() => this.addNote(MeetingList.id, MeetingList.changeDetail)}
                              >
											<Icon type="message" />แสดงความคิดเห็น</Button>
									</Col>
								</Row>
							</Col>
						)
					})
					:
					<Col xs={24} md={24} align={"center"} style={{ marginTop: "150px" }}>
						<Text>ไม่พบข้อมูล</Text>
					</Col>}
				<Col xs={{ span: 24, offset: 0 }}>
					{/*{dataMeeting}*/}
				</Col>
			</Row>
		)
	}
}


ViewInviteMeeting.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedAddMeeting = Form.create()(ViewInviteMeeting)

export default withApollo(WrappedAddMeeting)